export enum CorporateActionTypes {
  API_RESPONSE_SUCCESS = "@@devices/API_RESPONSE_SUCCESS",
  API_RESPONSE_ERROR = "@@devices/API_RESPONSE_ERROR",

  GET_CORPORATES = "@@devices/GET_CORPORATES",
  UPDATE_CORPORATES = "@@devices/UPDATE_CORPORATES",
  ADD_CORPORATES = "@@devices/ADD_CORPORATES",
  DELETE_CORPORATES = "@@devices/DELETE_CORPORATES",
  CLEAR_ERROR = "@@devices/CLEAR_ERROR",
}
